var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 17H21M2 5.25C2 4.38805 2.34241 3.5614 2.9519 2.9519C3.5614 2.34241 4.38805 2 5.25 2H28C28.862 2 29.6886 2.34241 30.2981 2.9519C30.9076 3.5614 31.25 4.38805 31.25 5.25V28C31.25 28.862 30.9076 29.6886 30.2981 30.2981C29.6886 30.9076 28.862 31.25 28 31.25H5.25C4.38805 31.25 3.5614 30.9076 2.9519 30.2981C2.34241 29.6886 2 28.862 2 28V5.25Z",
    stroke: "#E9EAE8",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnPending);
export default __webpack_public_path__ + "static/media/btnPending.1f8207d333fb4edee988a557dea8a586.svg";
export { ForwardRef as ReactComponent };